import { createContext } from 'react';

/**
 * Access token from TokenGate's initial silent auth.
 * Gate only (truthy = session usable) — not Auth0's isAuthenticated.
 * API calls pull a fresh token via apiClient's token provider; this string may be stale.
 */
export const TokenContext = createContext<string | null>(null);
